import axios from 'axios'
import config from '../config'
import { getHeaders } from './ApiService'

export type ProjectBaseline = {
  _id: string
  name: string
  source: 'ms_project' | 'pl4nner'
  createdAt: string
  createdBy?: { _id: string; name?: string; firstName?: string; lastName?: string; avatar?: string; image?: string }
}

export const getProjectBaselines = async (projectId: string) =>
  (await axios.get(`${config.apiHost}/projects/${projectId}/baselines`, { headers: getHeaders() })).data.data

export const createProjectBaseline = async (projectId: string, name: string) =>
  (await axios.post(`${config.apiHost}/projects/${projectId}/baselines`, { name }, { headers: getHeaders() })).data.data

export const getProjectBaselineTasks = async (projectId: string, baselineId: string) =>
  (await axios.get(`${config.apiHost}/projects/${projectId}/baselines/${baselineId}/tasks`, { headers: getHeaders() })).data.data

export const selectProjectBaseline = async (settingsId: string, baselineId: string) =>
  (await axios.patch(`${config.apiHost}/user-project-settings/${settingsId}/selected-baseline`, { baselineId }, { headers: getHeaders() })).data.data

export const updateProjectBaselineTask = async (projectId: string, baselineId: string, taskId: string, data: any) =>
  (await axios.patch(`${config.apiHost}/projects/${projectId}/baselines/${baselineId}/tasks/${taskId}`, data, { headers: getHeaders() })).data.data
